import { useNavigate } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { Card } from "@/components/ui/card"
import { Calendar, Clock, MapPin, Users2 } from "lucide-react"

export default function ThankYouPage() {
  const navigate = useNavigate()

  // Clear saved form data and checkout item ID on successful payment
  sessionStorage.removeItem('checkOutItemId');
  sessionStorage.removeItem('savedFormData');
  sessionStorage.removeItem('retryUrl');

  return (
    <div className="min-h-[80vh] bg-gradient-to-b from-green-50 to-white">
      <div className="container max-w-4xl py-16 px-4">
        <div className="space-y-8 animate-fade-in">
          {/* Success Icon */}
          <div className="flex justify-center">
            <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center">
              <svg
                className="w-10 h-10 text-primary"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
          </div>

          {/* Thank You Message */}
          <div className="text-center space-y-4">
            <h1 className="text-4xl font-bold text-gray-900">
              Thank You for Your Booking!
            </h1>
            <p className="text-lg text-gray-600">
              Your event registration is confirmed and on its way.
              We've sent you a confirmation email with all the details.
            </p>
          </div>

          {/* Decorative Elements */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Card className="p-6 bg-muted hover:shadow-md transition-shadow">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                  <Calendar className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">What's Next?</h3>
                  <p className="text-gray-600">
                    Check your email for event details and instructions
                  </p>
                </div>
              </div>
            </Card>

            <Card className="p-6 bg-muted hover:shadow-md transition-shadow">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                  <Users2 className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Need Help?</h3>
                  <p className="text-gray-600">
                    Our support team is here to assist you
                  </p>
                </div>
              </div>
            </Card>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-8">
            <Button
              variant="outline"
              onClick={() => navigate("/dashboard")}
              className="min-w-[200px]"
            >
              Go to Dashboard
            </Button>
            <Button
              onClick={() => navigate("/opportunities")}
              className="min-w-[200px]"
            >
              Browse More Events
            </Button>
          </div>

          {/* Confetti Animation */}
          <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
            <div className="absolute top-10 left-10 w-4 h-4 bg-primary/20 rounded-full animate-ping" />
            <div className="absolute top-20 right-20 w-3 h-3 bg-secondary/20 rounded-full animate-ping" style={{ animationDelay: "0.2s" }} />
            <div className="absolute bottom-40 left-1/4 w-5 h-5 bg-accent/20 rounded-full animate-ping" style={{ animationDelay: "0.4s" }} />
            <div className="absolute top-1/3 right-1/3 w-6 h-6 bg-muted/20 rounded-full animate-ping" style={{ animationDelay: "0.6s" }} />
          </div>
        </div>
      </div>
    </div>
  )
}